var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',_vm._l((_vm.items),function(item,i){return _c('v-list-item',{key:i},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(" "+_vm._s(item.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_c('common-text',{staticClass:"text-wrap",attrs:{"text":item.text}})],1)],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }